

export const FORM_TRANSFER_PATH = 'form_contactar/';
export const FORM_TRANSFER_FIELDS = `titulo_formulario,descripcion_formulario,alt_image,texto_boton_volver,
texto_boton_enviar,texto_sitio_seguro,imagen.filename_disk`;

export const CONTACT_CENTER_FIELDS = 'texto_contact_center,numero_contact_center';
export const HEADER_FIELDS = 'titulo_banner_l1,titulo_banner_l2';
export const DISCLAIMER_FIELDS = 'titulo_disclaimer,disclaimer';
